<template>
  <div class="header-wrapper">
    <div class="video-header">
      <span v-permission="'script:view'" class="script-title" :title="scriptTitle">{{ displayScriptTitle }}</span>
    </div>
  </div>
</template>

<script setup>
/* global defineProps */
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({
  preloadedScripts: {
    type: Array,
    default: () => []
  }
})
const route = useRoute()
const scriptTitle = computed(() => {
  const script = props.preloadedScripts.find(item => String(item.id) === String(route.params.scriptId))
  return script?.title || script?.name || '未命名剧本'
})
const displayScriptTitle = computed(() => {
  const characters = Array.from(scriptTitle.value)
  return characters.length > 25 ? `${characters.slice(0, 25).join('')}…` : scriptTitle.value
})
</script>

<style scoped>
.header-wrapper { min-width: 0; flex: 0 0 auto; }
.video-header { display: flex; align-items: center; min-height: 38px; }
.script-title { padding: 0 12px; color: #ededed; font-size: 14px; line-height: 1.5; font-weight: 500; overflow-wrap: anywhere; }
@media (max-width: 900px) {
  .script-title { font-size: 13px; }
}
</style>
